import React from 'react';

import { IBaseProps } from '@rbi-ctg/frontend';

import { HeaderContainer, HeaderText } from './styled';

export * from './styled';

export const Header: React.FC<IBaseProps> = ({ children, className }) => {
  if (typeof children !== 'string') {
    return null;
  }

  return (
    <HeaderContainer className={className}>
      <HeaderText>{children}</HeaderText>
    </HeaderContainer>
  );
};
